import React from 'react'
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import { Divider, IconButton, Paper, Typography } from '@material-ui/core';
import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
import LocationCityRoundedIcon from '@material-ui/icons/LocationCityRounded';


import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { blue } from '@material-ui/core/colors';
import { FlagOutlined, StorefrontOutlined, StoreOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    contentPaper:{  
        width: "100%",
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        alignItems:'flex-start',
        height: 'auto',
    }, 

    input:{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems:'flex-start',   
        flexDirection:'column',
        width: "100%",
        height: 'auto',
     
        paddingBottom: theme.spacing(1),
    }, 

   title: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems:'center',
    textTransform: 'uppercase',
    fontSize: '0.8rem',
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
   },

   address: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems:'center',
    marginLeft: theme.spacing(1), 
    paddingTop: theme.spacing(0.3),
   },

   addressDetails: {
    display: 'flex',
    alignItems:'flex-top',
    width: "100%",
    marginLeft: theme.spacing(1), 
    paddingTop: theme.spacing(0.3),
   },


   addressIcon: {
    marginRight:theme.spacing(1), 
    fontSize: '1.8rem',
   },
   detailsIcon: {
    marginRight:theme.spacing(1.5), 
    fontSize: '1.5rem',
   },

   addressText: {
    fontSize: '0.9rem',
    marginRight:theme.spacing(1.2), 
   },
   detailsText: {
    fontSize: '1.3em',
    alignSelf: 'left',
    width: "100%",
   // backgroundColor: 'blue',
   },

   contentData: {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    //backgroundColor: 'green',
    width: "100%",
   },

   contentText: {
    display: 'flex', 
    flexDirection: 'column',
    //justifyContent: 'space-between', 
    //backgroundColor: 'green'
   },

   contentEdit: {
    display: 'flex', 
    //justifyContent: 'flex-end', 
    //backgroundColor: 'red',  
   },

   edit: {
    fontSize: '1.3em',
   },


}));


export default function OutputAddress(props) {
    const classes = useStyles();
    const {fullAddress,icon, addressTitle, onClickStore, onClickEdit, iconColor,onClickDelete, onClickAddress} = props; 
   // console.log("PanelButtons , Selected:",fullAddress);


    const handlerClickStore = ()=>{
        //console.debug("handlerClickStore");
        if(onClickStore){
            onClickStore(); 
        }
    }

    const handlerOnEdit = ()=>{
        if(!onClickEdit){
            return; 
        }
        onClickEdit();
    }

    const handlerOnDelete = ()=>{
        if(!onClickDelete){
            return;
        }
        onClickDelete(fullAddress);
    }

    const handlerClickItem = ()=>{
        if(!onClickAddress){
            return;
        }
        onClickAddress(fullAddress);
    }

    return (
        <div className={classes.contentPaper}>
           {fullAddress && 
             <div className={classes.input}>
                { addressTitle &&  
                <Typography className={classes.title}>{addressTitle}</Typography>
                }

                <div className={classes.contentData}>

                    <div className={classes.contentText} onClick={handlerClickItem} >
                        { fullAddress.address && 
                            <div className={classes.address}>

                                {icon==undefined && 
                                <LocationOnRoundedIcon 
                                    className={classes.addressIcon} 
                                    color={!iconColor ? 'disabled': iconColor}
                                    />
                                }
                                {icon=='store' && 
                                <StoreOutlined
                                    className={classes.addressIcon} 
                                    color={!iconColor ? 'disabled': iconColor}
                                    onClick ={handlerClickStore}
                                    />
                                }
                                {icon=='flag' &&
                                <FlagOutlined
                                    className={classes.addressIcon} 
                                    color={!iconColor ? 'disabled': iconColor}
                                />
                                }

                                <Typography variant ='body2'  className={classes.addressText}>
                                    {fullAddress.address}
                                </Typography>               
                            </div>
                        }
                        { fullAddress.details && 
                            <div className={classes.addressDetails}>
                                <LocationCityRoundedIcon 
                                        className={classes.detailsIcon}
                                        color={!iconColor ? 'disabled': iconColor}
                                        />
                    
                                <Typography variant ='body2' className={classes.detailsText}>
                                    {fullAddress.details}
                                </Typography>                     
                            </div>
                        }
                    </div>

                { onClickEdit && 
                    <div className={classes.contentEdit}>                
                        <IconButton 
                        className={classes.edit}
                        aria-label="Checkout" 
                        color="accent"
                        onClick ={handlerOnEdit}
                        >
                        <EditIcon></EditIcon>   
                        </IconButton>
                    </div>
                } 
                { onClickDelete && 
                    <div className={classes.contentEdit}>                
                        <IconButton 
                        className={classes.edit}
                        aria-label="Checkout" 
                        color="default"
                        onClick ={handlerOnDelete}
                        >
                        <DeleteIcon/>
                        </IconButton>
                    </div>
                }   
                </div>
                      
            </div>
            }
         
      </div>
    )
}
